import ApiClient from './ApiClient'

export default class AppsClient extends ApiClient {
    load = () => this.get('/applications')

    create = ({ name }) => this.post('/application', { application_name: name })

    update = ({ params }) => this.put(`/application`, params)

    getCurrent = () => this.get(`/application`)

    deleteApplication = () => this.delete(`/application`)
}
